import { shallowEqual, useSelector } from "react-redux";

import styleLayout from "../core/styles/PageLayout.module.scss";

import ColumnSelectionButton from "../core/ColumnSelectionButton.js";
import DataTableContainer from "../core/grid/DataTableContainer.js";
import { type INavPanelCategory } from "../core/navigation-panel/NavigationPanel.js";
import PageHeader from "../core/navigation-panel/PageHeader.js";
import PageLayout from "../core/navigation-panel/PageLayout.js";
import { type InputTableQuerySpec } from "@/graphql.ts";
import { type ITableData, createUniqueKeyFromTableSpec, getTableDataSlice } from "@/redux/modules/table-data.ts";
import { type IAppState } from "@/redux/reducer.ts";
import { ENTITY_TYPE, SESSION_TABLE_COLUMNS } from "@/settings/settings.js";

export const ANALYST_SESSIONS_MENU_ITEMS: INavPanelCategory[] = [
  {
    label: "Analyst Sessions",
    tooltip: "Show the Analyst sessions",
    // licenseModule: LICENSE_MODULE.ANALYST,
    navItems: [
      {
        label: "Overview",
        route: "/",
        pageComponent: <ContentBrowserSessionsTablePage />,
      },
    ],
  },
];

export default function AnalystSessionsPage() {
  return <PageLayout navPanelCategories={ANALYST_SESSIONS_MENU_ITEMS} navPanelCollapsed />;
}

const analystSessionsTableSpec: InputTableQuerySpec = {
  resultType: ENTITY_TYPE.ANALYST_SESSION,
};

const analystSessionsTableInitOptions = {
  sortExpression: `-${SESSION_TABLE_COLUMNS.MODIFIED}`,
};

function ContentBrowserSessionsTablePage() {
  const tableData: ITableData = useSelector<IAppState, ITableData>(
    (state) => getTableDataSlice(state.tableData, analystSessionsTableSpec),
    shallowEqual,
  );

  // create count label
  const getCount = (): string => {
    if (tableData?.totalRowCount) {
      if (tableData.filteredRowCount === tableData.totalRowCount) {
        return String(tableData.totalRowCount);
      } else if (tableData.filteredRowCount < tableData.totalRowCount) {
        return `${tableData.filteredRowCount} of ${tableData.totalRowCount}`;
      }
    }
  };

  return (
    <>
      <PageHeader
        title={"Analyst Sessions"}
        setDocumentTitle
        badge={getCount()}
        actionWidgets={[
          <ColumnSelectionButton
            portalContext={createUniqueKeyFromTableSpec(tableData?.tableQuerySpec)}
            key={"analyst-sessions-page-widget-1"}
          />,
        ]}
      />
      <div className={styleLayout.page} style={{ backgroundColor: "white" }}>
        <DataTableContainer
          key={createUniqueKeyFromTableSpec(analystSessionsTableSpec)}
          tableSpec={analystSessionsTableSpec}
          hideCheckboxes={true}
          tableInitializationOptions={analystSessionsTableInitOptions}
        />
      </div>
    </>
  );
}
